<template>
    <v-container class="pa-12">
        <v-card class="pl-16 pr-16 pt-8 pb-16">
            <v-card-title>
                <v-row>
                    <v-col cols="6" md="6">
                        <h3>Quotation / ใบเสนอราคา</h3>
                    </v-col>
                    <v-col cols="6" md="6">
                        <v-row>
                            <v-col class="text-right" cols="12" md="12">
                                <h5>No. {{ doc.doc_no }}</h5>
                                <h5>Date {{ doc.doc_date_show }}</h5>
                                <v-chip x-small :color="statusColor" dark class="mt-1">🔒 {{ statusLabel }}</v-chip>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-title>

            <div v-if="doc.doc_type === 'estimate'" class="wf-alert wf-alert-warn">
                ⏱️ เอกสารนี้เป็น <b>การประมาณการค่าบริการเบื้องต้น (Non-binding Estimate)</b>
                อยู่ระหว่างดำเนินการ (In Progress) — ผูก Invoice ได้หลายใบ ดูรายละเอียดด้านล่าง
            </div>

            <!-- ===== Header fields: ล็อกทั้งหมด (read-only) ===== -->
            <v-row class="row1 mt-3 pt-3">
                <v-col cols="12" md="6">
                    <v-text-field v-model="doc.client_code" label="Client Code" outlined dense
                        background-color="#F5F5F5" disabled></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field v-model="doc.client_name" label="Client Name" outlined dense
                        background-color="#F5F5F5" disabled></v-text-field>
                </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
                <v-col cols="12" md="10">
                    <v-text-field v-model="doc.client_address" label="Client Address" outlined dense
                        background-color="#F5F5F5" disabled></v-text-field>
                </v-col>
            </v-row>
            <!-- <v-row class="heightsize70formadvance">
                <v-col cols="12" md="10">
                    <v-text-field v-model="doc.invoice_address" label="Invoice Address" outlined dense
                        background-color="#F5F5F5" disabled placeholder="auto-fill จาก Client Master"></v-text-field>
                </v-col>
            </v-row> -->
            <v-row class="heightsize70formadvance">
                <v-col cols="12" md="3">
                    <v-text-field v-model="doc.tax_id" label="Tax ID" outlined dense background-color="#F5F5F5"
                        disabled></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="doc.branch" label="Branch" outlined dense background-color="#F5F5F5"
                        disabled></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="doc.payment_term" label="Payment Term (Day)" outlined dense
                        background-color="#F5F5F5" disabled></v-text-field>
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select :items="currency_list" v-model="doc.currency" item-text="curr" item-value="curr"
                        label="Currency" outlined dense hide-details background-color="#F5F5F5" disabled></v-select>
                </v-col>
            </v-row>
            <v-row class="heightsize70formadvance">
                <v-col cols="12" sm="3">
                    <v-text-field v-model="doc.vat_percent" label="Vat rate (%)" outlined dense
                        background-color="#F5F5F5" disabled></v-text-field>
                </v-col>
                <v-col cols="6" md="3">
                    <v-text-field v-model="doc.attention" label="Attention" outlined dense background-color="#F5F5F5"
                        disabled></v-text-field>
                </v-col>
                <v-col cols="6" md="3">
                    <v-text-field v-model="doc.contact_position" label="Contact Position" outlined dense
                        background-color="#F5F5F5" disabled></v-text-field>
                </v-col>
            </v-row>
            <!-- <v-row class="heightsize70formadvance">
                <v-col cols="12" md="4">
                    <v-text-field v-model="doc.po_no" label="PO No." outlined dense
                        :disabled="!headerEditable"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-menu v-model="menuPoDate" :close-on-content-click="false" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="doc.po_date" label="PO Date" append-icon="mdi-calendar" readonly
                                outlined dense :disabled="!headerEditable" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
<v-date-picker v-model="doc.po_date" @input="menuPoDate = false"></v-date-picker>
</v-menu>
</v-col>
<v-col cols="12" sm="4">
    <v-menu v-model="menuDeliveryDate" :close-on-content-click="false" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="doc.delivery_date" label="Delivery Date" append-icon="mdi-calendar"
                                readonly outlined dense :disabled="!headerEditable" v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
        <v-date-picker v-model="doc.delivery_date" @input="menuDeliveryDate = false"></v-date-picker>
    </v-menu>
</v-col>
</v-row> -->

            <v-row class="row1 mt-3 pt-3">
                <v-col cols="12" md="12">
                    <v-textarea v-model="doc.additional_info" solo label="Additional information" disabled auto-grow
                        rows="4"></v-textarea>
                </v-col>
            </v-row>
            <!-- ===== Fixed Price item table (read-only) ===== -->
            <template v-if="doc.doc_type === 'fixed'">
                <div class="d-flex justify-space-between align-center mt-4 mb-1">

                    <h3 class="text-subtitle-1 mb-0">รายการสินค้า/บริการ</h3>



                </div>
                <div class="wf-alert wf-alert-info">
                    <v-icon small color="#0d47a1">mdi-information-outline</v-icon>
                    VAT rate {{ Number(doc.vat_percent).toFixed(2) }}% จะใช้กับรายการที่เปิด 'คิด VAT' เท่านั้น
                </div>
                <v-card outlined tile>
                    <v-simple-table dense>
                        <thead>
                            <tr class="bg-colorth">
                                <th class="texttablehcenter" style="width:36px">No.</th>
                                <th class="texttablehcenter" style="min-width:180px">ชื่อสินค้า/รายละเอียด</th>
                                <th class="texttablehcenter text-right" style="width:80px">จำนวน</th>
                                <th class="texttablehcenter" style="width:90px">หน่วย</th>
                                <th class="texttablehcenter text-right" style="width:120px">ราคาต่อหน่วย</th>
                                <th class="texttablehcenter text-right" style="width:120px">ราคาก่อน VAT</th>
                                <th class="texttablehcenter text-center" style="width:110px">คิด VAT</th>
                                <th class="texttablehcenter text-right" style="width:100px">VAT</th>
                                <th class="texttablehcenter text-right" style="width:120px">ราคารวม</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in doc.items" :key="row.id">
                                <td>{{ idx + 1 }}</td>
                                <td>
                                    {{ row.name }}
                                    <div v-if="row.detail" class="caption blue--text multiline-detail">{{ row.detail }}
                                    </div>
                                </td>
                                <td class="text-right">{{ row.qty }}</td>
                                <td>{{ row.unit }}</td>
                                <td class="text-right">{{ fmt(row.price) }}</td>
                                <td class="text-right">{{ fmt(row.qty * row.price) }}</td>
                                <td class="text-center">
                                    <v-chip x-small :color="row.applyVat ? '#E3F2FD' : '#EEEEEE'"
                                        :text-color="row.applyVat ? '#1565C0' : '#757575'">
                                        {{ row.applyVat ? 'คิด VAT' : 'ไม่คิด VAT' }}
                                    </v-chip>
                                </td>
                                <td class="text-right">{{ fmt(row.applyVat ? (row.qty * row.price) *
                                    (Number(doc.vat_percent) / 100) : 0) }}</td>
                                <td class="text-right font-weight-medium">
                                    {{ fmt(row.applyVat ? (row.qty * row.price) * (1 + Number(doc.vat_percent) / 100) :
                                        (row.qty * row.price)) }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>

                <div class="d-flex justify-space-between align-center mt-3 mb-2 flex-wrap">
                    <span class="text-body-2 grey--text">
                        <v-icon small color="blue" class="mt-n1">mdi-information-outline</v-icon>
                        {{ fixedTotals.rowCount }} รายการ • คิด VAT {{ fixedTotals.vatCount }} • ไม่คิด VAT {{
                            fixedTotals.noVatCount }}
                    </span>
                </div>

                <v-row justify="end">
                    <v-col cols="12" md="5">
                        <v-card outlined class="summary-card pa-4">
                            <div class="summary-title font-weight-bold mb-3">สรุปยอด</div>

                            <div class="d-flex align-center summary-row mb-1">
                                <div class="summary-label">ยอดรวมก่อน VAT</div>
                                <div class="summary-value">{{ fmt(fixedTotals.total) }} {{ doc.currency }}</div>
                            </div>

                            <div class="d-flex align-center summary-row mb-1">
                                <div class="summary-label">รายการที่ติด VAT</div>
                                <div class="summary-value">{{ fmt(fixedTotals.vatBase) }} {{ doc.currency }}</div>
                            </div>

                            <div class="d-flex align-center summary-row mb-2">
                                <div class="summary-label">รายการที่ไม่ติด VAT</div>
                                <div class="summary-value">{{ fmt(fixedTotals.noVatBase) }} {{ doc.currency }}</div>
                            </div>

                            <v-divider class="mb-2"></v-divider>

                            <div class="d-flex align-center summary-row mb-2">
                                <div class="summary-label">VAT {{ Number(doc.vat_percent).toFixed(2) }}%</div>
                                <div class="summary-value">{{ fmt(fixedTotals.vat) }} {{ doc.currency }}</div>
                            </div>

                            <v-divider class="mb-2"></v-divider>

                            <div class="d-flex align-center summary-row summary-total-box">
                                <div class="summary-label font-weight-bold">ยอดสุทธิ</div>
                                <div class="summary-value text-h6 font-weight-bold primary--text">{{
                                    fmt(fixedTotals.grandTotal) }} {{ doc.currency }}</div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </template>

            <!-- ===== Estimate Fee item table (read-only) — ผูก Invoice ได้หลายใบ (1:N) ===== -->
            <template v-else>
                <div class="d-flex justify-space-between align-center mt-4 mb-1">
                    <h3 class="text-subtitle-1 mb-0">รายการบริการ (ประมาณการ)</h3>
                </div>
                <div class="wf-alert wf-alert-info">
                    <v-icon small color="#0d47a1">mdi-information-outline</v-icon>
                    VAT rate {{ Number(doc.vat_percent).toFixed(2) }}% จะใช้กับรายการที่เปิด 'คิด VAT' เท่านั้น
                </div>
                <v-card outlined tile>
                    <v-simple-table dense>
                        <thead>
                            <tr class="bg-colorth">
                                <th class="texttablehcenter" style="width:36px">No.</th>
                                <th class="texttablehcenter" style="min-width:200px">ชื่อสินค้า/รายละเอียด</th>
                                <th class="texttablehcenter text-right" style="width:150px">(Rate/Hr.) / Estimate Fees
                                </th>
                                <th class="texttablehcenter text-right" style="width:120px">ราคาก่อน VAT</th>
                                <th class="texttablehcenter text-center" style="width:110px">คิด VAT</th>
                                <th class="texttablehcenter text-right" style="width:100px">VAT</th>
                                <th class="texttablehcenter text-right" style="width:120px">ราคารวม</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in doc.items" :key="row.id">
                                <td>{{ idx + 1 }}</td>
                                <td>
                                    {{ row.name }}
                                    <div v-if="row.detail" class="caption blue--text multiline-detail">{{ row.detail }}
                                    </div>
                                </td>
                                <td class="text-right">{{ fmt(row.rate) }}</td>
                                <td class="text-right">{{ fmt(row.rate) }}</td>
                                <td class="text-center">
                                    <v-chip x-small :color="row.applyVat ? '#E3F2FD' : '#EEEEEE'"
                                        :text-color="row.applyVat ? '#1565C0' : '#757575'">
                                        {{ row.applyVat ? 'คิด VAT' : 'ไม่คิด VAT' }}
                                    </v-chip>
                                </td>
                                <td class="text-right">{{ fmt(row.applyVat ? (Number(row.rate) || 0) *
                                    (Number(doc.vat_percent) / 100) : 0) }}</td>
                                <td class="text-right font-weight-medium">
                                    {{ fmt(row.applyVat ? (Number(row.rate) || 0) * (1 + Number(doc.vat_percent) / 100)
                                        :
                                        (Number(row.rate) || 0)) }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>

                <v-row class="mt-4">
                    <v-col cols="12" md="6">
                        <v-text-field :value="doc.not_to_exceed_cap || 'ไม่ระบุ'"
                            label="วงเงินไม่เกิน (Not-to-Exceed Cap)" outlined dense background-color="#F5F5F5"
                            disabled></v-text-field>
                    </v-col>
                </v-row>

                <div class="d-flex justify-space-between align-center mt-3 mb-2 flex-wrap">
                    <span class="text-body-2 grey--text">
                        <v-icon small color="blue" class="mt-n1">mdi-information-outline</v-icon>
                        {{ estimateTotals.rowCount }} รายการ • คิด VAT {{ estimateTotals.vatCount }} • ไม่คิด VAT {{
                            estimateTotals.noVatCount }}
                    </span>
                </div>

                <v-row justify="end">
                    <v-col cols="12" md="5">
                        <v-card outlined class="summary-card pa-4">
                            <div class="summary-title font-weight-bold mb-3">สรุปยอด</div>

                            <div class="d-flex align-center summary-row mb-1">
                                <div class="summary-label">ยอดรวมก่อน VAT</div>
                                <div class="summary-value">{{ fmt(estimateTotals.total) }} {{ doc.currency }}</div>
                            </div>

                            <div class="d-flex align-center summary-row mb-1">
                                <div class="summary-label">รายการที่ติด VAT</div>
                                <div class="summary-value">{{ fmt(estimateTotals.vatBase) }} {{ doc.currency }}</div>
                            </div>

                            <div class="d-flex align-center summary-row mb-2">
                                <div class="summary-label">รายการที่ไม่ติด VAT</div>
                                <div class="summary-value">{{ fmt(estimateTotals.noVatBase) }} {{ doc.currency }}</div>
                            </div>

                            <v-divider class="mb-2"></v-divider>

                            <div class="d-flex align-center summary-row mb-2">
                                <div class="summary-label">VAT {{ Number(doc.vat_percent).toFixed(2) }}%</div>
                                <div class="summary-value">{{ fmt(estimateTotals.vat) }} {{ doc.currency }}</div>
                            </div>

                            <v-divider class="mb-2"></v-divider>

                            <div class="d-flex align-center summary-row summary-total-box">
                                <div class="summary-label font-weight-bold">ยอดสุทธิ</div>
                                <div class="summary-value text-h6 font-weight-bold primary--text">{{
                                    fmt(estimateTotals.grandTotal) }} {{ doc.currency }}</div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </template>

            <v-row class="mt-2 mb-2">
                <v-col align="right" cols="12">
                    <v-btn outlined color="#1565C0" @click="onPrint">
                        🖨️ Print / PDF
                    </v-btn>
                </v-col>
            </v-row>

            <!-- ===== Invoice ที่ผูกกับเอกสารนี้ — ใช้ตารางเดียวกันทั้ง Quotation (1:1) และ Fee Estimate (1:N) ===== -->
            <v-card outlined class="mt-4 pa-4">
                <div class="d-flex justify-space-between align-center mt-4 mb-1">
                    <h3 class="text-subtitle-1 mb-0">เอกสารนี้ถูกแปลงเป็นใบแจ้งหนี้</h3>
                </div>
                <v-card outlined tile>
                    <v-simple-table dense>
                        <thead>
                            <tr class="bg-colorth">
                                <th class="texttablehcenter">Invoice No.</th>
                                <th class="texttablehcenter">Date</th>
                                <th class="texttablehcenter">รอบบิล</th>
                                <th class="texttablehcenter text-right">Amount</th>
                                <th class="texttablehcenter">Status</th>
                                <th class="texttablehcenter">Preview</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="inv in doc.linked_invoices" :key="inv.invoice_no">
                                <td class="text-center">{{ inv.invoice_no }}</td>
                                <td class="text-center">{{ inv.date }}</td>
                                <td class="text-center">{{ inv.period }}</td>
                                <td class="text-right">{{ fmt(inv.amount) }}</td>
                                <td class="text-center">
                                    <v-chip x-small :color="inv.status === 'Paid' ? 'green' : 'blue'" dark>{{ inv.status
                                        }}</v-chip>
                                </td>
                                <td class="text-center">
                                    <a href="#" @click.prevent="onViewInvoice(inv.id, inv.status)">ดูใบแจ้งหนี้</a>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
                <div class="text-right caption grey--text mt-2">
                    ยอดเรียกเก็บสะสมจากทุก Invoice จนถึงปัจจุบัน:
                    <b class="black--text">{{ fmt(cumulativeInvoiced) }}</b>
                </div>

                <!-- Note 17: เทียบยอดสะสมกับวงเงินไม่เกิน เฉพาะตอนมีการระบุไว้ตอนสร้างเอกสาร (Fee Estimate เท่านั้น) -->
                <div v-if="hasCap" class="mt-2"
                    :class="capExceeded ? 'wf-alert wf-alert-warn' : 'wf-alert wf-alert-info'">
                    <span v-if="capExceeded">⚠️ ยอดเรียกเก็บสะสมเกินวงเงินไม่เกินที่กำหนดไว้แล้ว</span>
                    <span v-else>ℹ️ เทียบกับวงเงินไม่เกิน</span>
                    : {{ fmt(cumulativeInvoiced) }} / {{ fmt(capAmount) }}
                    (คงเหลือ {{ fmt(Math.max(capAmount - cumulativeInvoiced, 0)) }})
                </div>
            </v-card>

            <br />
            <hr />
            <br />
            <div>
                <v-row>
                    <v-col align="center" cols="12" md="12">
                        <v-btn outlined class="mr-5" @click="getBackList()">
                            Back
                        </v-btn>
                        <v-btn class="mr-5 buttonblue" disabled>
                            Save Draft
                        </v-btn>
                        <v-btn depressed class="mr-5 buttonblue" disabled>
                            Submit
                        </v-btn>
                    </v-col>
                </v-row>
                <!-- ไม่มีปุ่ม Delete ตาม REQ-2 — สถานะ Invoiced/InProgress ล็อกทั้งหมด -->
            </div>
        </v-card>
        <v-dialog v-model="dialogSelectTitle" scrollable max-width="35%">
            <v-card class="pa-4">

                <v-card-text>
                    <div class="d-flex align-center mb-0 mt-5">
                        <span class="text-h5 font-weight-bold">Select Company</span>
                    </div>

                    <v-radio-group v-model="dialogSelectClientInfo" column>
                        <v-radio label="DEJ-UDOM & ASSOCIATES LIMITED" value="1" class="mb-2"></v-radio>
                        <v-radio label="สำนักงานกฎหมาย เดชอุดม แอนด์แอสโซซิเอทส์" value="3" class="mb-2"></v-radio>
                    </v-radio-group>
                </v-card-text>

                <v-card-actions style="margin-top: -30px;">
                    <v-row no-gutters>
                        <v-col cols="6" class="pr-2">
                            <v-btn color="#106a94" large rounded dark elevation="0" @click="confirmPrint" block>
                                Print Preview
                            </v-btn>
                        </v-col>
                        <v-col cols="6" class="pl-2">
                            <v-btn color="#fc1526" large rounded dark elevation="0" @click="dialogSelectTitle = false"
                                block>
                                Cancel
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showVatDetailDialog" max-width="820px" scrollable content-class="vat-dialog-card">
            <v-card class="pa-6">
                <div class="d-flex justify-space-between align-start mb-1">
                    <div>
                        <div class="text-h5 font-weight-bold">รายละเอียดการคำนวณ VAT</div>
                        <div class="text-body-2 grey--text mt-1">คำนวณจากมูลค่ารายการก่อน VAT</div>
                    </div>
                    <v-btn icon @click="showVatDetailDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-card outlined class="mt-4 vat-table-card">
                    <v-simple-table dense class="vat-detail-table">
                        <thead>
                            <tr>
                                <th>รายการ</th>
                                <th class="text-center">มูลค่าก่อน VAT<br />(THB)</th>
                                <th class="text-center">อัตรา VAT</th>
                                <th class="text-center">VAT<br />(THB)</th>
                                <th class="text-center">รวมหลัง VAT<br />(THB)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in vatDetailRows" :key="idx">
                                <td>{{ row.name }}</td>
                                <td class="text-right">{{ fmt(row.base) }}</td>
                                <td class="text-center">
                                    <v-chip v-if="row.applyVat" x-small color="#E3F2FD" text-color="#1565C0">{{
                                        row.vatRate
                                        }}%</v-chip>
                                    <span v-else class="grey--text text-caption">ไม่คิด VAT</span>
                                </td>
                                <td class="text-right">
                                    <div class="font-weight-medium">{{ fmt(row.vatAmount) }}</div>
                                    <div v-if="row.applyVat" class="text-caption grey--text">{{ fmt(row.base) }} × {{
                                        row.vatRate }}%</div>
                                </td>
                                <td class="text-right font-weight-medium">{{ fmt(row.afterVat) }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>

                <v-card outlined class="summary-card vat-summary-card pa-4 mt-4">
                    <div class="d-flex align-center summary-row mb-2">
                        <div class="summary-label">
                            <div>ยอดรายการทั้งหมด</div>
                            <div class="text-caption grey--text">รวมทุกแถวในตาราง</div>
                        </div>
                        <div class="summary-value">{{ fmt(vatDetailTotals.total) }} {{ doc.currency }}</div>
                    </div>
                    <div class="d-flex align-center summary-row mb-2">
                        <div class="summary-label">
                            <div>VAT รวม</div>
                            <div class="text-caption grey--text">เฉพาะรายการที่เลือกคิด VAT</div>
                        </div>
                        <div class="summary-value">{{ fmt(vatDetailTotals.vat) }} {{ doc.currency }}</div>
                    </div>
                    <div class="d-flex align-center summary-row summary-total-box">
                        <div class="summary-label">
                            <div class="font-weight-bold">ยอดชำระทั้งหมด</div>
                            <div class="text-caption grey--text">รวม VAT แล้ว</div>
                        </div>
                        <div class="summary-value vat-grand-total font-weight-bold primary--text">{{
                            fmt(vatDetailTotals.grandTotal) }} {{ doc.currency }}</div>
                    </div>
                </v-card>

                <div class="text-caption grey--text mt-3 text-center">
                    <v-icon x-small color="grey">mdi-information-outline</v-icon>
                    VAT คำนวณเฉพาะรายการที่เลือกคิด VAT
                </div>

                <v-card-actions class="mt-4 px-0">
                    <v-spacer></v-spacer>
                    <v-btn color="#1565C0" dark rounded elevation="0" width="120"
                        @click="showVatDetailDialog = false">ปิด</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <PdfPreviewDialog v-model="dialogPDF" :blob="pdfBlob" :filename="getFileName()" />

    </v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import Swal from "sweetalert2";
import pdfQuotationGenerator from "@/utils/pdfQuotationGenerator";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";

export default {
    name: "QuotationView",
    components: { PdfPreviewDialog },
    data() {
        return {
            currency_list: [],
            showVatDetailDialog: false,
            pdfBlob: null,
            pdfObj: null,
            dialogPDF: false,
            print_header_list: [
                {
                    id: "1", // ตรงกับ <v-radio value="1"> (DEJ-UDOM & ASSOCIATES LIMITED)
                    com_title: "STATEMENT",
                    com_name: "",
                    inv_company_name_th: "",
                    inv_company_address: "",
                    inv_company_branch: "",
                    inv_company_tel: "",
                    inv_company_email: "",
                    inv_tax_id: "",
                    com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
                    com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                    com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
                    com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
                    com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
                    com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
                    // ✅ เพิ่ม: ชื่อบริษัทแบบ Title Case ไว้ใช้แทรกในข้อความ Quotation Terms
                    // ให้ตรงกับหัวเอกสารที่เลือกจริง (ต้องมี "Ltd." ต่อท้ายสำหรับบริษัทนี้)
                    com_display_name: "Dej-Udom & Associates Ltd.",
                    customer_paymentterm: "0",
                    credit_term_date: "",
                },
                {
                    id: "3", // ตรงกับ <v-radio value="3"> (สำนักงานกฎหมาย เดชอุดม แอนด์แอสโซซิเอทส์)
                    com_title: "STATEMENT",
                    com_name: "",
                    inv_company_name_th: "",
                    inv_company_address: "",
                    inv_company_branch: "",
                    inv_company_tel: "",
                    inv_company_email: "",
                    inv_tax_id: "",
                    com_eng_1: "DEJ-UDOM & ASSOCIATES",
                    com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                    com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
                    com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
                    com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
                    com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
                    // ✅ เพิ่ม: สำนักงานนี้ไม่มี "Ltd." ต่อท้าย ต้องตรงกับหัวเอกสาร (com_eng_1 ด้านบน)
                    com_display_name: "Dej-Udom & Associates",
                    customer_paymentterm: "0",
                    credit_term_date: "",
                },
            ],
            dialogSelectTitle: false,
            dialogSelectClientInfo: "1",
            doc: {
                doc_no: "",
                doc_type: "fixed",
                status: "Invoiced",
                doc_date_show: "",
                client_code: "",
                client_name: "",
                client_address: "",
                tax_id: "",
                branch: "",
                payment_term: "0",
                currency: "THB",
                vat_percent: "7.00",
                not_to_exceed_cap: "",
                items: [],
                linked_invoices: [],
            },
            clientOptions: [],
        };
    },
    computed: {
        headerEditable() {
            return !this.isLocked; // Draft และ Submitted แก้ header ได้
        },
        statusLabel() {
            return { Invoiced: "Invoiced", InProgress: "In Progress" }[this.doc.status] || this.doc.status;
        },
        statusColor() {
            return { Invoiced: "green", InProgress: "purple" }[this.doc.status] || "grey";
        },
        fixedTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            (this.doc.items || []).forEach((r) => {
                const lineTotal = (Number(r.qty) || 0) * (Number(r.price) || 0);
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: (this.doc.items || []).length,
            };
        },
        estimateTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            (this.doc.items || []).forEach((r) => {
                const lineTotal = Number(r.rate) || 0;
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: (this.doc.items || []).length,
            };
        },
        vatDetailRows() {
            const isFixed = this.doc.doc_type === "fixed";
            return (this.doc.items || []).map((row) => {
                const base = isFixed
                    ? (Number(row.qty) || 0) * (Number(row.price) || 0)
                    : (Number(row.rate) || 0);
                const vatAmount = row.applyVat ? base * ((Number(row.vatRate) || 0) / 100) : 0;
                return {
                    name: row.name || "-",
                    base,
                    applyVat: row.applyVat,
                    vatRate: row.vatRate,
                    vatAmount,
                    afterVat: base + vatAmount,
                };
            });
        },
        vatDetailTotals() {
            return this.doc.doc_type === "fixed" ? this.fixedTotals : this.estimateTotals;
        },
        estimateTotal() {
            // row.rate ถูก format เป็น string ผ่าน this.fmt() ตอน map มาแล้วใน loadQuotation()
            // ต้อง strip comma ก่อนแปลงเป็นตัวเลขกัน NaN
            return (this.doc.items || []).reduce((s, r) => {
                const raw = (r.rate || "").toString().replace(/,/g, "");
                return s + (Number(raw) || 0);
            }, 0);
        },
        cumulativeInvoiced() {
            return (this.doc.linked_invoices || []).reduce((s, inv) => s + inv.amount, 0);
        },
        // Note 17: เทียบยอดสะสมกับวงเงินไม่เกิน — แสดงเฉพาะตอนมีการระบุไว้ตอนสร้างเอกสารเท่านั้น
        hasCap() {
            const raw = (this.doc.not_to_exceed_cap || "").toString().replace(/,/g, "").trim();
            return raw !== "" && Number(raw) > 0;
        },
        capAmount() {
            const raw = (this.doc.not_to_exceed_cap || "").toString().replace(/,/g, "").trim();
            return Number(raw) || 0;
        },
        capExceeded() {
            return this.hasCap && this.cumulativeInvoiced > this.capAmount;
        },
    },
    async mounted() {
        try {
            await api.checkVersion();

            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Authorize Failed!!!",
                    "Please Logout And Login Again!!!",
                    "text-h5 red--text text-center"
                );
                this.$router.back();
                return;
            }

            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];

            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];

            if (!permission) {
                this.$router.back();
                return;
            }

            this.authorize_view = permission.smd_view >= 1;

            if (!this.authorize_view) {
                this.$router.back();
                return;
            }

            if (this.userId && api.isLoggedIn()) {
                // already logged in
            } else {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }
        } catch (error) {
            console.error("QuotationView mounted() auth error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
            return;
        }

        // ===== โหลดข้อมูลเอกสารจริง แยก catch ออกจาก auth =====
        this.$showLoader();
        try {
            await this.loadCurrency();
            await this.loadCustomer();
            await this.loadQuotation();
            if (this.doc.status == 'Invoiced') {
                await this.loadDataInvoice();
            } else {
                this.linked_invoices = [];
            }
        } catch (error) {
            console.error("QuotationView mounted() load data error:", error);
            await Swal.fire({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: "ไม่สามารถโหลดข้อมูลเอกสารได้ กรุณาลองใหม่อีกครั้ง",
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
        } finally {
            this.$hideLoader();
        }
    },
    methods: {
        async loadCurrency() {
            const res_cur = await api.getDataCurrency();
            this.currency_list = res_cur.data;
        },
        getFileName() {
            return `Quotation_${this.doc.doc_no || ((this.docType === "fixed" ? "QT-" : "EST-") + "(ออกอัตโนมัติเมื่อบันทึก)")}.pdf`
        },
        async loadCustomer() {
            const result = await api.getAllCustomerListactiveCompany({
                params: {
                    company_id: localStorage.getItem(server.COMPANYID),
                },
            });
            this.clientOptions = result.data.map((item) => ({
                id: item.id,
                code: item.cust_account,
                name: item.name,
                address: item.address,
                tax_id: item.taxid,
                branch: item.branch,
            }));
        },
        async loadQuotation() {
            const id = this.$route.params.id;

            try {
                const res = await api.billing_expense_getAllQuotationsByID(id);
                const record = res.data;

                if (!record) {
                    await Swal.fire({
                        icon: "error",
                        title: "ไม่พบเอกสาร",
                        text: "ไม่พบเอกสารที่ต้องการดู",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                    });
                    this.$router.push("/quotation-list");
                    return;
                }

                // ✅ แก้บั๊ก type mismatch
                const clientMatch = this.clientOptions.find(
                    (c) => Number(c.id) === Number(record.client_id)
                );

                const items = record.doc_type === "fixed"
                    ? (record.items || []).map((item) => ({
                        id: item.item_row_id,
                        name: item.item_name,
                        detail: item.detail || "",
                        qty: item.qty != null ? Number(item.qty) : 0,
                        unit: item.unit || "",
                        price: item.unit_price != null ? Number(item.unit_price) : 0,
                        applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                    }))
                    : (record.items || []).map((item) => ({
                        id: item.item_row_id,
                        name: item.item_name,
                        detail: item.detail || "",
                        rate: item.line_total != null ? Number(item.line_total) : 0,
                        applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                    }));
                console.log(record)
                this.doc = {
                    doc_no: record.doc_no,
                    doc_type: record.doc_type,
                    status: record.status,
                    doc_date: record.doc_date,
                    doc_date_show: this.formatDocDateShow(record.doc_date),
                    client_code: clientMatch ? clientMatch.code : "",
                    client_name: clientMatch ? clientMatch.name : (record.client ? record.client.name : `Client #${record.client_id}`),
                    client_address: record.client_address,
                    tax_id: clientMatch ? clientMatch.tax_id : "",
                    branch: clientMatch ? clientMatch.branch : "",
                    payment_term: String(record.payment_term ?? "0"),
                    currency: record.currency,
                    vat_percent: String(record.vat_percent ?? "0"),
                    attention: record.attention,
                    contact_position: record.contact_position,
                    po_no: record.po_no,
                    po_date: record.po_date,
                    delivery_date: record.delivery_date,
                    additional_info: record.additional_info,
                    not_to_exceed_cap: record.not_to_exceed_cap != null ? String(record.not_to_exceed_cap) : "",
                    items: items,
                    linked_invoices: [],
                };

            } catch (error) {
                console.error("loadQuotation error:", error);
                await Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: "ไม่สามารถโหลดข้อมูลเอกสารได้",
                    showConfirmButton: false,
                    timer: 2500,
                    timerProgressBar: true,
                });
                this.$router.push("/quotation-list");
            }
        },
        async loadDataInvoice() {
            const id = this.$route.params.id;
            try {
                const res_inv = await api.billing_expense_loaddata_quottions_invocie(Number(id));
                const invoices = res_inv.data || [];

                this.doc.linked_invoices = invoices.map((inv) => ({
                    id: inv.id,
                    invoice_no: inv.inv_id,
                    date: inv.inv_date,
                    period: inv.billing_period, // ยังไม่มีข้อมูล "รอบบิล" จาก API ตอนนี้ ใส่ placeholder ไว้ก่อน
                    amount: Number(inv.sub_total) || 0,
                    status: inv.inv_status,
                }));
            } catch (error) {
                console.error("loadDataInvoice error:", error);
                this.doc.linked_invoices = [];
            }
        },
        formatDocDateShow(dateOnly) {
            if (!dateOnly) return "";
            const [yyyy, mm, dd] = dateOnly.split("-");
            if (!yyyy || !mm || !dd) return "";
            return `${dd}/${mm}/${yyyy}`;
        },
        getBackList() {
            this.$router.push("/quotation-list");
        },
        fmt(n) {
            return (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        onViewInvoice(id, inv_status) {
            if (inv_status == "Invoice" || inv_status == "P.invoice") {
                const routeData = this.$router.resolve(`/edit-invoice/${id}/inv_h/edit`);
                window.open(routeData.href, "_blank");
            } else if (inv_status == "Receive") {
                const routeData = this.$router.resolve(`/edit-invoice/${id}/inv_h/edit`);
                window.open(routeData.href, "_blank");
            } else {
                return;
            }
        },
        async onPrint() {
            this.dialogSelectTitle = true;
        },
        async confirmPrint() {
            try {
                // เลือกข้อมูลบริษัทจาก print_header_list ตาม id ที่เลือกในไดอะล็อก
                // (fallback เป็นตัวแรกถ้าหาไม่เจอ กัน dialogSelectClientInfo ค้างค่าผิด)
                const selectedCompany =
                    this.print_header_list.find((c) => c.id === this.dialogSelectClientInfo) ||
                    this.print_header_list[0];

                const header = {
                    company_inv: "L", // ใช้ "L" เสมอเพราะเรากำหนด com_eng_1/com_thai/com_add_* เองครบแล้ว
                    com_eng_1: selectedCompany.com_eng_1,
                    com_eng_2: selectedCompany.com_eng_2,
                    com_thai: selectedCompany.com_thai,
                    com_add_name: selectedCompany.com_add_name,
                    com_add_no: selectedCompany.com_add_no,
                    com_add_city: selectedCompany.com_add_city,
                    com_add_country: selectedCompany.com_add_country,
                    com_add_tel: selectedCompany.com_add_tel,
                    com_add_email: selectedCompany.com_add_email,
                    com_add_tax_id: selectedCompany.com_add_tax_id,
                    // ✅ เพิ่ม: ใช้แทรกในข้อความ Quotation Terms เริ่มต้น ให้ตรงกับบริษัทที่เลือกจริง
                    company_display_name: selectedCompany.com_display_name,
                    doc_no: this.doc.doc_no,
                    doc_date: this.doc.doc_date,
                    doc_type: this.doc.doc_type,
                    customer_name: this.doc.client_name,
                    customer_address: this.doc.client_address,
                    customer_taxid: this.doc.tax_id,
                    attention: this.doc.attention,
                    payment_term: this.doc.payment_term,
                    currency: this.doc.currency,
                    subtotal: this.doc.doc_type === "fixed" ? this.fixedTotals.total : this.estimateTotals.total,
                    vat_percent: this.doc.vat_percent,
                    vat_base: this.doc.doc_type === "fixed" ? this.fixedTotals.vatBase : this.estimateTotals.vatBase,
                    no_vat_base: this.doc.doc_type === "fixed" ? this.fixedTotals.noVatBase : this.estimateTotals.noVatBase,
                    vat_amount: this.doc.doc_type === "fixed" ? this.fixedTotals.vat : this.estimateTotals.vat,
                    grand_total: this.doc.doc_type === "fixed" ? this.fixedTotals.grandTotal : this.estimateTotals.grandTotal,
                    amount_in_words: "",
                    not_to_exceed_cap: this.doc.not_to_exceed_cap,
                    additional_info: this.doc.additional_info,
                };

                const items = this.doc.items.map((row) => ({
                    description: row.name,
                    detail: row.detail,
                    apply_vat: !!row.applyVat,
                    amount: this.doc.doc_type === "fixed" ? (row.qty || 0) * (row.price || 0) : undefined,
                    rate: this.doc.doc_type === "estimate" ? row.rate : undefined,
                }));

                //ฟังก์ชันปริ้นเก่า
                // await pdfQuotationGenerator.exportToPDF({ header, items });

                //ฟังก์ชันปริ้นใหม่
                const blob = await pdfQuotationGenerator.exportToPDF({ header, items });
                this.pdfBlob = blob;
                this.dialogSelectTitle = false;
                this.dialogPDF = true;
                this.dialogSelectTitle = false;
            } catch (error) {
                this.dialogSelectTitle = false;
                console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
                alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
            }
        },


    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },

};
</script>

<style scoped>
.bg-colorth {
    background-color: #595959;
}

.texttablehcenter {
    color: #fff !important;
    text-align: center;
}

.heightsize70formadvance {
    height: 70px;
}

.heightsize55formadvance {
    height: 55px;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
    background-color: #1d2442;
    color: white;
}

.wf-alert {
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 13px;
    margin-bottom: 14px;
}

.wf-alert-info {
    background: #e3f2fd;
    color: #0d47a1;
    border-left: 4px solid #1565c0;
}

.wf-alert-warn {
    background: #fff3e0;
    color: #e65100;
    border-left: 4px solid #ef6c00;
}

.wf-alert-success {
    background: #e8f5e9;
    color: #1b5e20;
    border-left: 4px solid #2e7d32;
}

.multiline-detail {
    white-space: pre-line;
}

.summary-card {
    border-radius: 8px;
    background: #fff;
}

.summary-row {
    padding: 10px 12px;
    border-radius: 6px;
}

.summary-total-box {
    background: #e3f2fd;
}

.summary-label {
    flex: 1;
    min-width: 0;
}

.summary-value {
    flex-shrink: 0;
    text-align: right;
    white-space: nowrap;
    margin-left: 12px;
}

.summary-title {
    font-size: 25px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.3;
}

.vat-detail-link {
    color: #1565c0;
    font-size: 13px;
    text-decoration: underline;
    cursor: pointer;
}

.vat-detail-link:hover {
    color: #0d47a1;
}

.vat-dialog-card {
    border-radius: 16px;
}

.vat-table-card {
    border-radius: 8px;
    overflow: hidden;
}

.vat-detail-table {
    border-collapse: collapse;
}

.vat-detail-table th {
    font-weight: 600;
    color: #424242;
    background: #FAFAFA;
    font-size: 12.5px;
}

.vat-detail-table td {
    font-size: 13.5px;
}

.vat-detail-table th,
.vat-detail-table td {
    border-right: 1px solid #E0E0E0;
}

.vat-detail-table th:last-child,
.vat-detail-table td:last-child {
    border-right: none;
}

.vat-summary-card {
    font-size: 13px;
}

.vat-summary-card .summary-row {
    padding: 8px 10px;
}

.vat-grand-total {
    font-size: 18px;
}
</style>